// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SmtpForm-errorMessage-dPphs {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}
.SmtpForm-space1-q_4Gj {
	margin-bottom: 6px !important;
}
.SmtpForm-space2-PZvNO {
	margin-bottom: 12px !important;
}
.SmtpForm-space3-Sz4yy {
	margin-bottom: 18px !important;
}
.SmtpForm-space4-oISMi {
	margin-bottom: 24px !important;
}
.SmtpForm-space5-f7ODg {
	margin-bottom: 30px !important;
}
.SmtpForm-space6-n4Oxu {
	margin-bottom: 36px !important;
}
.SmtpForm-space7-eY6Ew {
	margin-bottom: 42px !important;
}
.SmtpForm-space8-DwzDo {
	margin-bottom: 48px !important;
}
.SmtpForm-spaceTop1-cZvaZ {
	margin-top: 6px !important;
}
.SmtpForm-spaceTop2-gouGS {
	margin-top: 12px !important;
}
.SmtpForm-spaceTop3-dAL_j {
	margin-top: 18px !important;
}
.SmtpForm-spaceTop4-Bf6JF {
	margin-top: 24px !important;
}
.SmtpForm-spaceTop5-Gec0P {
	margin-top: 30px !important;
}
.SmtpForm-spaceTop6-xMMgb {
	margin-top: 36px !important;
}
.SmtpForm-spaceTop7-v4A7S {
	margin-top: 42px !important;
}
.SmtpForm-spaceTop8-Sru3e {
	margin-top: 48px !important;
}
.SmtpForm-noMargin-s94L8 {
	margin: 0px !important;
}
.SmtpForm-padding1-UqoWl {
	padding-bottom: 6px !important;
}
.SmtpForm-padding2-i4yXu {
	padding-bottom: 12px !important;
}
.SmtpForm-padding3-EQfot {
	padding-bottom: 18px !important;
}
.SmtpForm-padding4-mcxTg {
	padding-bottom: 24px !important;
}
.SmtpForm-padding5-sZX58 {
	padding-bottom: 30px !important;
}
.SmtpForm-padding6-Xv9zT {
	padding-bottom: 36px !important;
}
.SmtpForm-padding7-c2wkK {
	padding-bottom: 42px !important;
}
.SmtpForm-paddingTop1-JK_Um {
	padding-top: 6px !important;
}
.SmtpForm-paddingTop2-LaKgQ {
	padding-top: 12px !important;
}
.SmtpForm-paddingTop3-sRSdl {
	padding-top: 18px !important;
}
.SmtpForm-paddingTop4-SnJD2 {
	padding-top: 24px !important;
}
.SmtpForm-paddingTop5-Cv8py {
	padding-top: 30px !important;
}
.SmtpForm-paddingTop6-MZYI8 {
	padding-top: 36px !important;
}
.SmtpForm-paddingTop7-guOkv {
	padding-top: 42px !important;
}
.SmtpForm-noPadding-bqUCv {
	padding: 0px !important;
}
.SmtpForm-spaceMarginBottom0-njhoH {
	margin-bottom: 0;
}
.SmtpForm-textBold-a6PEK {
	font-weight: 500 !important;
}
.SmtpForm-textBolder-pw6iW {
	font-weight: 700 !important;
}
.SmtpForm-textNormal-VQNvg {
	font-weight: normal !important;
}
/*New Design Text Colors */
.SmtpForm-textDarkBlue-FRZhz {
	color: rgb(20, 39, 94) !important;
}
.SmtpForm-textLightBlue-aTyPt {
	color: rgb(57, 87, 106) !important;
}
.SmtpForm-textLightSandleGreen-d6vQc {
	color: rgb(76, 86, 41) !important;
}
.SmtpForm-textLightBrown-HzPLT {
	color: rgb(115, 79, 33) !important;
}
.SmtpForm-textMediumMaroon-xpqfm {
	color: rgb(87, 37, 51) !important;
}
.SmtpForm-textBrown-ndnOg {
	color: rgb(160, 47, 24) !important;
}
.SmtpForm-textMaroon-t6d2P {
	color: rgb(155, 49, 67) !important;
}
.SmtpForm-textDarkBrown-k8bET {
	color: rgb(83, 18, 16) !important;
}
.SmtpForm-textMediumBrown-hZfey {
	color: rgb(142, 28, 10) !important;
}
.SmtpForm-textSkyBlue-CvMGO {
	color: rgb(37, 117, 141) !important;
}
.SmtpForm-textGray-_27kt {
	color: rgb(77, 65, 51) !important;
}
/** Admin - Common - Start **/
.SmtpForm-userText-osMU7 {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}
.SmtpForm-panelHeader-EI1XV {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}
.SmtpForm-exportSection-pziha {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}
.SmtpForm-exportSectionGridSub-fCxuI {
	grid-template-columns: 50% 49% !important;
}
.SmtpForm-exportText-gPYne {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}
.SmtpForm-exportLinkImg-C5hVY {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}
.SmtpForm-exportImg-shujJ {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}
.SmtpForm-linkBtn-BdPLo {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}
.SmtpForm-table-X6sv5 {
	display: table;
}
.SmtpForm-tableRow-WXV3X {
	display: table-row;
}
.SmtpForm-tableCell-XM3bc {
	display: table-cell;
	float: none;
}
.SmtpForm-formGroup-s1IWM {
	margin-bottom: 6px;
}
.SmtpForm-marginTop0-QTYPz {
	margin-top: 0;
}
.SmtpForm-marginBottom20-JN4JM {
	margin-bottom: 20px;
}
/******************* Admin Banner Image Section Start ****************/
.SmtpForm-bannerImageBg-tcz1g {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}
.SmtpForm-bannerDelete-_AO04 {
	position: absolute;
	top: 5px;
	right: 20px;
}
/*******************Admin Modal Start **********************/
a,
a:hover {
	cursor: pointer;
}
.SmtpForm-exportLink-CCkGw {
	padding-top: 10px;
	padding-right: 10px;
}
.SmtpForm-seachContent-D5SAo {
	padding-left: 0px;
	margin-bottom: 5px;
}
.SmtpForm-marginBottom9-dM2Bs {
	margin-bottom: 9px;
}
.SmtpForm-spaceTop52-JCR3N {
	margin-top: 52px;
}
.SmtpForm-profileViewInner-BT8gR {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}
.SmtpForm-profileViewMain-MA_y4 {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}
.SmtpForm-profileViewlabel-yiXYS {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}
.SmtpForm-profileViewMainContent-KJ_Hb {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}
.SmtpForm-reviewsFormStar-HJlC9 {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}
.SmtpForm-reviewsFormStar-HJlC9 svg {
	cursor: pointer;
}
.SmtpForm-addLanguageText-XXaFM {
	font-size: 16px;
}
/***************** Export Section Start *********************/
@media screen and (max-width: 991px) {
	.SmtpForm-exportSection-pziha {
		grid-template-columns: 100%;
	}

	.SmtpForm-spaceTop52-JCR3N {
		margin-top: 18px;
	}

	.SmtpForm-exportText-gPYne {
		float: none;
		margin-top: 12px;
	}

	.SmtpForm-exportSectionGridSub-fCxuI {
		grid-template-columns: 100% !important;
	}
}
/***************** Export Section End *********************/
/*******************Admin Modal Start **********************/
/*******************Admin Modal End **********************/
/*********************** Profile View Section  Start***********************/
@media screen and (max-width: 767px) {
	.SmtpForm-profileViewlabel-yiXYS {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.SmtpForm-profileViewMainContent-KJ_Hb {
		width: 100%;
		text-align: center;
	}

	.SmtpForm-panelHeader-EI1XV {
		padding: 15px 15px;
	}

}
/*********************** Profile View Section  Start***********************/
/** RentAll - Begin **/
.SmtpForm-checkBoxWidth-UZhHg {
  width: 34px;
}
.SmtpForm-textWidth-r0eFr {
  width: 88%;
  vertical-align: middle;
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/utils.css","webpack://./src/components/helpers.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/siteadmin/SmtpManagement/SmtpForm/SmtpForm.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;ACRA;CACC,6BAA6B;AAC9B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,0BAA0B;AAC3B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,uBAAuB;AACxB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,8BAA8B;AAC/B;AAEA,0BAA0B;AAE1B;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,mCAAmC;AACpC;AAEA;CACC,iCAAiC;AAClC;ACzLA,6BAA6B;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;AAEA;CACC,yCAAyC;AAC1C;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;AAEA;CACC,cAAc;AACf;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,aAAa;AACd;AAEA;CACC,mBAAmB;AACpB;AAGA,sEAAsE;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;AAEA,4DAA4D;AAC5D;;CAEC,eAAe;AAChB;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;AAEA;CACC,eAAe;AAChB;AAEA;CACC,eAAe;AAChB;AAEA,6DAA6D;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;AAEA,2DAA2D;AAC3D,4DAA4D;AAE5D,0DAA0D;AAE1D,2EAA2E;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;AAEA,2EAA2E;ACpN3E,sBAAsB;AACtB;EACE,WAAW;AACb;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,eAAe;AACjB","sourcesContent":[".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/","@import '../../../utils.css';\n@import '../../admin-common.css';\n@import '../../../helpers.css';\n\n/** RentAll - Begin **/\n.checkBoxWidth {\n  width: 34px;\n}\n\n.textWidth {\n  width: 88%;\n  vertical-align: middle;\n  font-size: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `SmtpForm-errorMessage-dPphs`,
	"space1": `SmtpForm-space1-q_4Gj`,
	"space2": `SmtpForm-space2-PZvNO`,
	"space3": `SmtpForm-space3-Sz4yy`,
	"space4": `SmtpForm-space4-oISMi`,
	"space5": `SmtpForm-space5-f7ODg`,
	"space6": `SmtpForm-space6-n4Oxu`,
	"space7": `SmtpForm-space7-eY6Ew`,
	"space8": `SmtpForm-space8-DwzDo`,
	"spaceTop1": `SmtpForm-spaceTop1-cZvaZ`,
	"spaceTop2": `SmtpForm-spaceTop2-gouGS`,
	"spaceTop3": `SmtpForm-spaceTop3-dAL_j`,
	"spaceTop4": `SmtpForm-spaceTop4-Bf6JF`,
	"spaceTop5": `SmtpForm-spaceTop5-Gec0P`,
	"spaceTop6": `SmtpForm-spaceTop6-xMMgb`,
	"spaceTop7": `SmtpForm-spaceTop7-v4A7S`,
	"spaceTop8": `SmtpForm-spaceTop8-Sru3e`,
	"noMargin": `SmtpForm-noMargin-s94L8`,
	"padding1": `SmtpForm-padding1-UqoWl`,
	"padding2": `SmtpForm-padding2-i4yXu`,
	"padding3": `SmtpForm-padding3-EQfot`,
	"padding4": `SmtpForm-padding4-mcxTg`,
	"padding5": `SmtpForm-padding5-sZX58`,
	"padding6": `SmtpForm-padding6-Xv9zT`,
	"padding7": `SmtpForm-padding7-c2wkK`,
	"paddingTop1": `SmtpForm-paddingTop1-JK_Um`,
	"paddingTop2": `SmtpForm-paddingTop2-LaKgQ`,
	"paddingTop3": `SmtpForm-paddingTop3-sRSdl`,
	"paddingTop4": `SmtpForm-paddingTop4-SnJD2`,
	"paddingTop5": `SmtpForm-paddingTop5-Cv8py`,
	"paddingTop6": `SmtpForm-paddingTop6-MZYI8`,
	"paddingTop7": `SmtpForm-paddingTop7-guOkv`,
	"noPadding": `SmtpForm-noPadding-bqUCv`,
	"spaceMarginBottom0": `SmtpForm-spaceMarginBottom0-njhoH`,
	"textBold": `SmtpForm-textBold-a6PEK`,
	"textBolder": `SmtpForm-textBolder-pw6iW`,
	"textNormal": `SmtpForm-textNormal-VQNvg`,
	"textDarkBlue": `SmtpForm-textDarkBlue-FRZhz`,
	"textLightBlue": `SmtpForm-textLightBlue-aTyPt`,
	"textLightSandleGreen": `SmtpForm-textLightSandleGreen-d6vQc`,
	"textLightBrown": `SmtpForm-textLightBrown-HzPLT`,
	"textMediumMaroon": `SmtpForm-textMediumMaroon-xpqfm`,
	"textBrown": `SmtpForm-textBrown-ndnOg`,
	"textMaroon": `SmtpForm-textMaroon-t6d2P`,
	"textDarkBrown": `SmtpForm-textDarkBrown-k8bET`,
	"textMediumBrown": `SmtpForm-textMediumBrown-hZfey`,
	"textSkyBlue": `SmtpForm-textSkyBlue-CvMGO`,
	"textGray": `SmtpForm-textGray-_27kt`,
	"userText": `SmtpForm-userText-osMU7`,
	"panelHeader": `SmtpForm-panelHeader-EI1XV`,
	"exportSection": `SmtpForm-exportSection-pziha`,
	"exportSectionGridSub": `SmtpForm-exportSectionGridSub-fCxuI`,
	"exportText": `SmtpForm-exportText-gPYne`,
	"exportLinkImg": `SmtpForm-exportLinkImg-C5hVY`,
	"exportImg": `SmtpForm-exportImg-shujJ`,
	"linkBtn": `SmtpForm-linkBtn-BdPLo`,
	"table": `SmtpForm-table-X6sv5`,
	"tableRow": `SmtpForm-tableRow-WXV3X`,
	"tableCell": `SmtpForm-tableCell-XM3bc`,
	"formGroup": `SmtpForm-formGroup-s1IWM`,
	"marginTop0": `SmtpForm-marginTop0-QTYPz`,
	"marginBottom20": `SmtpForm-marginBottom20-JN4JM`,
	"bannerImageBg": `SmtpForm-bannerImageBg-tcz1g`,
	"bannerDelete": `SmtpForm-bannerDelete-_AO04`,
	"exportLink": `SmtpForm-exportLink-CCkGw`,
	"seachContent": `SmtpForm-seachContent-D5SAo`,
	"marginBottom9": `SmtpForm-marginBottom9-dM2Bs`,
	"spaceTop52": `SmtpForm-spaceTop52-JCR3N`,
	"profileViewInner": `SmtpForm-profileViewInner-BT8gR`,
	"profileViewMain": `SmtpForm-profileViewMain-MA_y4`,
	"profileViewlabel": `SmtpForm-profileViewlabel-yiXYS`,
	"profileViewMainContent": `SmtpForm-profileViewMainContent-KJ_Hb`,
	"reviewsFormStar": `SmtpForm-reviewsFormStar-HJlC9`,
	"addLanguageText": `SmtpForm-addLanguageText-XXaFM`,
	"checkBoxWidth": `SmtpForm-checkBoxWidth-UZhHg`,
	"textWidth": `SmtpForm-textWidth-r0eFr`
};
module.exports = ___CSS_LOADER_EXPORT___;
